import React, { useState, useRef, useEffect, useCallback } from 'react';
// import { useTranslation } from "react-i18next";
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import { motion } from "framer-motion";
import "./index.scss";

import Pagination from "../../../../../components/ui/Pagination";
import NoDataFound from "../../../../../components/ui/NoDataFound";
import CustomToolTip from "../../../../../components/ui/Tooltip";
import Button from "../../../../../components/ui/Button";
import RadioButton from "../../../../../components/ui/RadioButton";
import { toaster } from "../../../../../components/ui/Toaster";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import { filterIcon, searchIcon, viewMoreIcon, infoBlueIcon } from "../../../../../utils/icons";
import { getloggedInUserType } from "../../../../../utils/util";

import apiEndpoints from "../../../../../apiEndpoints";

import { useSelector, useDispatch } from 'react-redux';
import { getGitLeaks, updateListData, resetUpdateListDataResponse, resetGitLeaksList } from "../../../../../store/actions/scanInfoAction";

const newFindingsOption = [    
    {
        label: "Yes",
        value: "yes"
    },
    {
        label: "No",
        value: "no"
    },
    {
        label: "All",
        value: "all"
    }
]

const statusOption = [    
    {
        label: "Open",
        value: "open"
    },
    {
        label: "Closed",
        value: "closed"
    },
    {
        label: "Won't Fix",
        value: "Wont_fix"
    }
]

const GitLeaks = () => {

    const gitleaksResponse = useSelector((state) => state.scanInfo?.gitLeaksList);
    const updateStatusListResponse = useSelector((state) => state?.scanInfo?.updateStatusList);

    const updateUrl = apiEndpoints.scanInfo.exposureManagemnet.concerningExposure.gitLeaks

    const dispatch = useDispatch();

    const {
        domainId,
        scanId,
        organizationId,
        triggerListFetch,
        setTriggerListFetch,
    } = useScanInfoContext();

    const viewMoreWrapperRef = useRef(null);
    const filterWrapperRef = useRef(null);

    const [searchValue, setSearchValue] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isSearchFocused, setIsSearchFocused] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [scanNotFound, setScanNotFound] = useState(false);
    const [gitLeaksList, setGitLeaksList] = useState(null);
    // modal state
    const [showActionModal, setShowActionModal] = useState(false);
    const [modalType, setModalType] = useState("")
    const [selectedData, setSelectedData] = useState("");
    const [modalLoading, setModalLoading] = useState(false);
    const [showViewMore, setShowViewMore] = useState(false);
    const [selectedValid, setSelectedValid] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");

    //filter value
    const [showFilter, setShowFilter] = useState(false);
    const [newFindingsType, setNewFindingsType] = useState("");
    const [statusSelected, setStatusSelected] = useState("");
    const [selectedFalsePositive, setSelectedFalsePositive] = useState("");

    //selected filter value
    const [selectedFilterValue, setSelectedFilterValue] = useState({});
    

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const applyFilter = () => {
        setCurrentPage(1);        
        setShowFilter(false);
        let obj = {
            findings: newFindingsType,
            status: statusSelected,
            falsePositive: selectedFalsePositive
        }
        setSelectedFilterValue(obj);
    }

    const isAnyFilterActive = Object.values(selectedFilterValue).some(value => Boolean(value));

    const resetFilterValue = () => {        
        setCurrentPage(1);
        setSelectedFilterValue({})
        setNewFindingsType("");
        setStatusSelected("");
        setSelectedFalsePositive("");
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && isSearchFocused) {
            onSearch()
        }
    }

    const onSearch = () => {
        setCurrentPage(1);
        setSearchQuery(searchValue);
    }

    const fetchdData = useCallback(()=>{
        setIsLoading(true)
        const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}`;
        const queryParams = searchQuery ? `&query=${searchQuery}` : "";
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const newFindings = selectedFilterValue.findings && selectedFilterValue.findings !== "all" ? `&new_record=${selectedFilterValue.findings === "yes" ? true : false}` : "";
        const falsePositive = selectedFilterValue.falsePositive && selectedFilterValue.falsePositive !== "all" ? `&false_positive=${selectedFilterValue.falsePositive === "yes" ? true : false}` : "";
        const status = selectedFilterValue.status ? `&status=${selectedFilterValue.status}` : ""
        const url = `${baseUrl}${params}${queryParams}${newFindings}${falsePositive}${status}`
        dispatch(getGitLeaks(url))
    },[dispatch, currentPage, currentPageSize, domainId, scanId, organizationId, searchQuery, selectedFilterValue])

    const confirmDelete = () => {
        setModalLoading(true)
        let obj = {
            domain: selectedData?.domain,
            scan_id: selectedData?.scan_id,
            result_id: selectedData?.id
        }
        dispatch(updateListData(updateUrl.gitLeakDelete(), obj))
    }

    const saveUpdate = () => {
        setModalLoading(true)
        let obj = {
            domain: selectedData?.domain,
            scan_id: selectedData?.scan_id,
            result_id: selectedData?.id,
            false_positive: selectedValid === "valid" ? false : true
        }
        dispatch(updateListData(updateUrl.gitLeakValidate(), obj))
    }

    const updateStatus = () => {
        setModalLoading(true)
        let obj = {
            domain: selectedData?.domain,
            scan_id: selectedData?.scan_id,
            result_id: selectedData?.id,
            status: selectedStatus
        }
        dispatch(updateListData(updateUrl.gitLeakStatus(), obj))
    }

    const updateRetest = () => {
        setModalLoading(true)
        let obj = {
            domain: selectedData?.domain,
            scan_id: selectedData?.scan_id,
            result_id: selectedData?.id
        }
        if(modalType === "start") {
            dispatch(updateListData(updateUrl.gitLeakStart(), obj))
        } else {
            dispatch(updateListData(updateUrl.gitLeakStop(), obj))
        }
    }

    useEffect(() => {
        if (triggerListFetch) {
            setCurrentPage(1);
            setTriggerListFetch(false);
        }
    }, [triggerListFetch, currentPage, setTriggerListFetch]);

    useEffect(() => {
        fetchdData();       
    }, [searchQuery, currentPage, fetchdData]);

    useEffect(()=>{
        if(gitleaksResponse !== null) {
            setGitLeaksList(gitleaksResponse)
            if(gitleaksResponse?.status === "failed") {
                setScanNotFound(true)
            } else {
                setScanNotFound(false)
            }
            dispatch(resetGitLeaksList())
            setIsLoading(false)
        }
    },[gitleaksResponse, dispatch])

    useEffect(()=>{
        if(updateStatusListResponse !== null) {
            setShowActionModal(false)
            setModalLoading(false)
            if(updateStatusListResponse?.status === "success") {
                toaster.addToast(updateStatusListResponse?.description,"success")
                fetchdData()
            } else {
                toaster.addToast(updateStatusListResponse?.description,"error")
            }
            dispatch(resetUpdateListDataResponse())
        }
    },[updateStatusListResponse, fetchdData, dispatch])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (viewMoreWrapperRef.current && !viewMoreWrapperRef.current.contains(event.target)) {
                if(showViewMore){
                    setShowViewMore(false)
                }
            }        
        }
    },[showViewMore])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if(showFilter){
                    setShowFilter(false)
                }
            }
        
        }
    },[showFilter])


    return ( 
        <>
            <div className="git-leaks-main-content bg-white-with-shadow p-3 ">
                <div className="search-header-container d-flex align-items-center gap-3">
                    <div className="d-flex gap-3">
                        <div className="search-container position-relative" onKeyDown={handleSearchKeyDown}>
                            <span className="position-absolute">{searchIcon()}</span>
                            <input type="text" 
                                placeholder="Search" 
                                value={searchValue} 
                                onChange={(e)=>{
                                    setSearchValue(e.target.value)
                                }}
                                onFocus={() => setIsSearchFocused(true)}
                                onBlur={() => setIsSearchFocused(false)}
                            />
                        </div>
                        <button className="search-btn" onClick={onSearch}>Search</button>
                    </div>                    
                    <div className="position-relative">
                        <span className="filter-icon" onClick={()=>{setShowFilter(true)}}>{filterIcon()}</span>
                        {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                        {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>
                            <h6>New Findings</h6>
                            <div className="filter-user-status d-flex mb-4 gap-4">
                                {
                                    newFindingsOption.map((data,index)=>{
                                        return (
                                            <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setNewFindingsType(value)}} key={index} isChecked={data.value === newFindingsType} />
                                        )
                                    })
                                }
                            </div>
                            {getloggedInUserType() === "internal" && <>
                                <h6>False Positive</h6>
                                <div className="filter-user-status d-flex mb-4 gap-4">
                                    {
                                        newFindingsOption.map((data,index)=>{
                                            return (
                                                <RadioButton radioId={`false-positive-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setSelectedFalsePositive(value)}} key={index} isChecked={data.value === selectedFalsePositive} />
                                            )
                                        })
                                    }
                                </div>
                            </>}                            
                            <h6>Status</h6>
                            <div className="filter-user-status d-flex mb-4 gap-4">
                                {
                                    statusOption.map((data,index)=>{
                                        return (
                                            <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setStatusSelected(value)}} key={index} isChecked={data.value === statusSelected} />
                                        )
                                    })
                                }
                            </div>
                            <div className="filter-apply-btn mt-3">
                                <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={newFindingsType === "" && statusSelected === "" && selectedFalsePositive === ""} buttonClicked={()=>{applyFilter()}}/>
                            </div>
                        </div>}
                    </div>
                </div>
                <div className="table-container git-laks-table mt-3">
                    {
                        isLoading ?
                        <SkeletonLoader type={"line"} count={5} currentPage={"gitleaks"} />
                        :
                        <Table responsive="lg">
                            <thead>
                                <tr>
                                    <th>Repository Details</th>
                                    <th>Git Details</th>
                                    <th>Authors/Commiters</th>
                                    <th>Status</th>
                                    <th>Retest</th>
                                    <th>Source</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    gitLeaksList?.results?.length > 0 &&
                                    gitLeaksList?.results?.map((data, index) => {
                                        return (
                                            <motion.tr
                                                key={index}
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                            >
                                                <td className="repo-details">
                                                    <ul type="none" className="m-0 p-0">
                                                        <li className="d-flex justify-content-between gap-3">
                                                            <span>Owner: </span>
                                                            <span>{data?.owner}</span>
                                                        </li>
                                                        <li className="d-flex justify-content-between gap-3">
                                                            <span>Repo: </span>
                                                            <span>{data?.repo_name}</span>
                                                        </li>
                                                    </ul>
                                                    {data?.new_record && <p className="d-inline-block new-data my-2">New</p>}
                                                    {data?.false_positive && <p className="d-inline-block false-positive">False Positive</p>}
                                                </td>
                                                <td className="repo-url author-details">
                                                    <p className="heading-text mb-2">Url:</p>
                                                    <a className="text-overflow" href={data?.url} target="_blank"  rel="noreferrer">{data?.url}</a>
                                                    <p className="heading-text my-2">AI Summary:</p>
                                                    {data?.ai_summary !== null ? <span className="author-name">{
                                                        data?.ai_summary.length > 120 ?
                                                        <CustomToolTip content={data?.ai_summary} position={"top"}>
                                                            {data?.ai_summary.slice(0, 120) + "..." }
                                                        </CustomToolTip>                                                         
                                                        : data?.ai_summary
                                                    }</span> : "-"}
                                                </td>
                                                <td className="author-details">
                                                    <p className="heading-text mb-2">Authors:</p>
                                                    <span className="author-name">{data?.authors.join(", ")}</span>
                                                    <p className="heading-text text-bold my-2">Commiters:</p>
                                                    <span className="author-name">{data?.committers.join(",")}</span>
                                                </td>
                                                <td className="status-container">
                                                    {data.status === "open" && <p className="status open">{data?.status}</p>}
                                                    {data.status === "closed" && <p className="status closed">{data?.status}</p>}
                                                    {data.status === "wont_fix" && <p className="status warn">Won't Fix</p>}
                                                </td>
                                                <td className="retest-summary">
                                                    <div className="finding-list">
                                                        <ul type="none" className="m-0 p-0">
                                                            <li className="d-flex justify-content-between gap-3">
                                                                <span>Status: </span>
                                                                {data?.retest?.status === "pending" && 
                                                                    <span className="retest-status pending">{data?.retest?.status}</span>
                                                                }
                                                                {data?.retest?.status === "in_progress" && 
                                                                    <span className="retest-status inprogress"> In Progress</span>
                                                                }
                                                                {data?.retest?.status === "completed" && 
                                                                    <span className="retest-status completed">{data?.retest?.status}</span>                                                                    
                                                                }
                                                                {data?.retest?.status === "failed" && 
                                                                    <span className="retest-status failed">Failed
                                                                        {data?.retest?.summary !== null && <CustomToolTip content={data?.retest?.summary } position={"top"}>
                                                                            <span className="info-icon">{infoBlueIcon()}</span>
                                                                        </CustomToolTip>}
                                                                    </span>
                                                                }
                                                                {data?.retest?.status === "stopped" && 
                                                                    <span className="retest-status stopped">{data?.retest?.status}</span>
                                                                }
                                                                {
                                                                    (data?.retest?.status === "" || data?.retest?.status === null) && <span>-</span>
                                                                }
                                                            </li>
                                                            <li className="d-flex justify-content-between gap-3">
                                                                <span>Fixed: </span>
                                                                <span className="retest-status">{
                                                                    (data?.retest?.is_fixed !== null && data?.retest?.is_fixed !== "") 
                                                                    ? data?.retest?.is_fixed ? "Yes" : "No" : "-"}
                                                                    {data?.retest?.summary !== null && data?.retest?.status !== "failed" && <CustomToolTip content={data?.retest?.summary } position={"top"}>
                                                                        <span className="info-icon">{infoBlueIcon()}</span>
                                                                    </CustomToolTip>}
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                                <td className="source-containe">
                                                    {data?.source}
                                                </td>
                                                <td>
                                                    <div className="view-more-div position-relative">
                                                        <span onClick={()=>{
                                                            setSelectedData(data)
                                                            setShowViewMore(true)
                                                        }}>{viewMoreIcon()}</span>
                                                        {showViewMore && data.id === selectedData.id && <div className="more-option-container position-absolute" ref={viewMoreWrapperRef}>
                                                            {getloggedInUserType() === "internal" && <p onClick={()=>{
                                                                setModalType("valid")
                                                                setSelectedValid(data?.false_positive ? "falsePositive" : "valid")
                                                                setShowActionModal(true)
                                                            }}>Validate</p>}
                                                            <p onClick={()=>{
                                                                setModalType("delete")
                                                                setShowActionModal(true)
                                                            }}>Delete</p>
                                                            <p onClick={()=>{
                                                                setModalType("updateStatus")
                                                                setSelectedStatus(data?.status)
                                                                setShowActionModal(true)
                                                            }}>Update Status</p>
                                                            {data?.retest?.status !== "in_progress" && data?.retest?.status !== "pending" ? <p onClick={()=>{
                                                                    setModalType("start")
                                                                    setShowActionModal(true)
                                                                }}>Start - Retest</p> 
                                                                :
                                                                <p onClick={()=>{
                                                                    setModalType("stop")
                                                                    setShowActionModal(true)
                                                                }}>Stop - Retest</p>
                                                            }
                                                        </div>}
                                                    </div>
                                                </td>
                                            </motion.tr>
                                        )                                        
                                    })
                                }
                            </tbody>
                        </Table>
                    }
                    {
                        !isLoading && scanNotFound && 
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <NoDataFound noDataText={gitLeaksList?.description} />
                        </motion.div>
                    }
                    {
                        !isLoading && !scanNotFound && gitLeaksList !== "" && gitLeaksList?.results?.length === 0 && 
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <NoDataFound noDataText={"No Record Found"}/>
                        </motion.div>
                    }
                    {gitLeaksList !== "" && gitLeaksList?.results?.length > 0 && <Pagination
                        className="pagination-bar"
                        currentPage={currentPage}
                        pageSize={currentPageSize}
                        totalCount={gitLeaksList?.meta?.total_results}
                        onPageChange={setCurrentPageandRecordSize}
                    />}            
                </div>
                <Modal
                    show={showActionModal}
                    onHide={() => setShowActionModal(false)}
                    size="md"
                    centered
                    >
                        {modalType === "delete" && <Modal.Body>
                            <div className="delete-organization-container">
                                <h4>Delete</h4>
                                <div className="organization-related-details p-4 m-2">
                                    <p>Are you sure, want to delete?</p>                                    
                                </div>
                                <div className="delete-organization-btn d-flex gap-3 m-2">
                                    <Button buttonText="Cancel" buttonType={"secondary"} buttonClicked={() => setShowActionModal(false)}/>
                                    {!modalLoading && <Button buttonText="Delete" buttonType={"primary"} buttonClicked={() => confirmDelete()} />}
                                    {modalLoading && <Button buttonText="Loading..." disableButton={true} buttonType={"secondary"} />}
                                </div>
                            </div>
                        </Modal.Body>}
                        {modalType === "valid" && <Modal.Body>
                            <div className="delete-organization-container">
                                <h4>Validate</h4>
                                <div className="organization-related-details p-4 m-2">
                                    <p className="mb-4">Please Select below option</p>
                                    <div className="filter-user-status d-flex mb-4 gap-4">
                                        <RadioButton radioId={1} radioValue={"valid"} radioLabel={"Valid"} onChange={(data)=>{setSelectedValid(data)}} isChecked={selectedValid === "valid"} />
                                        <RadioButton radioId={2} radioValue={"falsePositive"} radioLabel={"False Positive"} onChange={(data)=>{setSelectedValid(data)}} isChecked={selectedValid === "falsePositive"} />
                                    </div>
                                </div>
                                <div className="d-flex gap-3 m-2">
                                    <Button buttonText="Cancel" buttonType={"secondary"} buttonClicked={() => setShowActionModal(false)}/>
                                    {!modalLoading && <Button buttonText="Save" buttonType={"primary"} disableButton={selectedValid === ""} buttonClicked={() => saveUpdate()} />}
                                    {modalLoading && <Button buttonText="Loading..." buttonType={"primary"} disableButton={true} />}
                                </div>
                            </div>
                        </Modal.Body>}
                        {modalType === "updateStatus" && <Modal.Body>
                            <div className="delete-organization-container">
                                <h4>Update Status</h4>
                                <div className="organization-related-details p-4 m-2">
                                    <p className="mb-4">Please Select below option</p>
                                    <div className="filter-user-status d-flex mb-4 gap-4">
                                        <RadioButton radioId={1} radioValue={"open"} radioLabel={"Open"} onChange={(data)=>{setSelectedStatus(data)}} isChecked={selectedStatus === "open"} />
                                        <RadioButton radioId={2} radioValue={"closed"} radioLabel={"Close"} onChange={(data)=>{setSelectedStatus(data)}} isChecked={selectedStatus === "closed"} />
                                        <RadioButton radioId={3} radioValue={"wont_fix"} radioLabel={"won't Fix"} onChange={(data)=>{setSelectedStatus(data)}} isChecked={selectedStatus === "wont_fix"} />
                                    </div>
                                    {(selectedStatus === "closed" || selectedStatus === "wont_fix") && 
                                        <>
                                            <p className="mb-4">Comments</p>
                                            <textarea className="status-comments w-100" placeholder="Comments"></textarea>
                                        </>
                                    }
                                </div>
                                <div className="d-flex gap-3 m-2">
                                    <Button buttonText="Cancel" buttonType={"secondary"} buttonClicked={() => setShowActionModal(false)}/>
                                    {!modalLoading && <Button buttonText="Save" buttonType={"primary"} disableButton={selectedStatus === ""} buttonClicked={() => updateStatus()} />}
                                    {modalLoading && <Button buttonText="Loading..." buttonType={"primary"} disableButton={true} />}
                                </div>
                            </div>
                        </Modal.Body>}
                        {(modalType === "start" ||  modalType === "stop") && <Modal.Body>
                            <div className="delete-organization-container">
                                <h4>Update Retest</h4>
                                <div className="organization-related-details p-4 m-2">
                                    {modalType === "start" && <p className="mb-4">Are you want to start retest?</p>}                                   
                                    {modalType === "stop" && <p className="mb-4">Are you want to stop retest?</p>}                                  
                                </div>
                                <div className="d-flex gap-3 m-2">
                                    <Button buttonText="Cancel" buttonType={"secondary"} buttonClicked={() => setShowActionModal(false)}/>
                                    {!modalLoading && <Button buttonText="Save" buttonType={"primary"} buttonClicked={() => updateRetest()} />}
                                    {modalLoading && <Button buttonText="Loading..." buttonType={"primary"} disableButton={true} />}
                                </div>
                            </div>
                        </Modal.Body>}
                </Modal>
            </div>
        </>        
    )
}


export default GitLeaks;